import { Injectable } from "@angular/core";
import { Api } from "./api";

@Injectable({
  providedIn: 'root',
})
export class ChangedPasswordService {
  private endpoint = '/account/change-password';

  constructor(private api: Api) {}



changePassword(payload: { currentPassword: string; newPassword: string }) {
  return this.api.post(`${this.endpoint}`, payload);
}


}

